import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import { reducer as ChangePasswordReducer } from '../modules/ChangePassword';
import { inquirySliceReducer as InquiryReducer, newAccountSliceReducer as newAccountReducer } from '../modules/Inquiry';
import { reducer as LoginReducer } from '../modules/Login';
import { reducer as ReissuePasswordReducer} from '../modules/ReissuePassword';
import { reducer as ViewerReducer } from '../modules/Viewer';

export const createRootReducer = (history: any) => {
  return combineReducers({
    router: connectRouter(history),
    login: LoginReducer,
    viewer: ViewerReducer,
    inquiry: InquiryReducer,
    newAccount: newAccountReducer,
    changePassword: ChangePasswordReducer,
    reissuePassword: ReissuePasswordReducer,
  });
};
